import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import TransactionsFormHandle from '@Modules/reporting/containers/forms/visaBase2/visaDetailsOutgoing/transactions/TransactionsFormHandle';
import FeesFormHandle from '@Modules/reporting/containers/forms/visaBase2/visaDetailsOutgoing/fees/FeesFormHandle';
import MessagesFormHandle from '@Modules/reporting/containers/forms/visaBase2/visaDetailsOutgoing/messages/MessagesFormHandle';
import RequestsFormHandle from '@Modules/reporting/containers/forms/visaBase2/visaDetailsOutgoing/requests/RequestsFormHandle';
import VisaFraudDeclarationFormHandle from '@Modules/reporting/containers/forms/visaBase2/visaDetailsOutgoing/visaFraudDeclaration/VisaFraudDeclarationFormHandle';


const VisaDetailsOutgoing = () => {
  return (
    <div>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Données VISA sortantes
        </CC.Text>
        <CC.Tabs>
          <div style={{overflowX: "auto"}}>
          <CC.TabList>
            <CC.Tab minWidth={'fit-content'}>Transactions</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Frais</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Messages</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Demandes</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Déclaration des cas de fraude VISA</CC.Tab>
          </CC.TabList>
          </div>

          <CC.TabPanels>
            <CC.TabPanel>
              <TransactionsFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <FeesFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <MessagesFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <RequestsFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <VisaFraudDeclarationFormHandle />
            </CC.TabPanel>
          </CC.TabPanels>
        </CC.Tabs>
      </CC.Box>

    </div>
  )
}

export default VisaDetailsOutgoing;